<template>
<div>
    <header>
        お知らせ
        <div class="h-left">
            <a @click="
            $router.push({ name: 'profile' });
            setFooter(true);
          "><img src="~@/assets/images/icon02.svg" /></a>
        </div>
        
        <div class="h-right btn disabled" @click="handleReadAllNotice">
            全て既読
        </div>
    </header>
    <div id="wrap2" style="overflow-x: hidden">
        <div v-for="(item, index) in noticeList" :key="index">
            <a v-if="item.type !== TYPE_NOTICE_BANNER" @click="goToDetail(item)">
                <div class="list" style="position: relative;">
                    <div class="clearfix">
                        <!-- <div class="list-img">
                            <img src="~@/assets/images/logo.svg" />
                        </div> -->
                        <div>
                            <div class="notice-label" v-if="parseInt(item.is_read) !== IS_READ ">
                                <span class="notice-label-text">未読</span>
                            </div>
                            <table style="table-layout: fixed; width: 100%">
                                <tr>
                                    <td>
                                        <div style="display: flex;">
                                            <span class="list-name ellipsis" style="flex: 1">{{ item.title }}</span>
                                            <span style="text-align: end; width: 64px">{{ item.posted_at }}</span>
                                        </div>
                                    </td>
                                    <td rowspan="2" style="width: 50px; text-align: center ;vertical-align: middle;">
                                        <i style="font-size: 24px;" class="fa fa-angle-right"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ellipsis-2line">
                                        <span>{{ item.content }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </a>
            <a v-else :href="item.url">
                <div class="list" style="height: 56px;">
                    <span class="list-name">{{ item.displayname }}</span>
                </div>
            </a>
        </div>
    </div>
    <infinite-loading @infinite="getNoticeList" style="height: 1px" spinner="spiral" :identifier="infiniteId">
        <template v-slot:no-more></template>
        <template v-slot:no-results>
            <div id="wrap3">
                <div id="middle" style="width:100%">
                    お知らせはありません。
                </div>
            </div>
        </template>
    </infinite-loading>
    <alertDialogBottom :active="isAlert">
        全て既読にしました。
    </alertDialogBottom>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import CONSTANTS from "@/constants";
import mixin from "@/mixin";
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
export default {
    data: () => ({
        pageSize: 10,
        pageCurrent: 1,
        noticeList: [],
        IS_READ: CONSTANTS.IS_READ,
        TYPE_NOTICE_BANNER: CONSTANTS.TYPE_NOTICE_BANNER,
        TYPE_NOTICE_CONTACT: CONSTANTS.TYPE_NOTICE_CONTACT,
        infiniteId: +new Date(),
        isAlert: false
    }),
  components: {
    alertDialogBottom
  },
    mixins: [mixin],
    mounted() {
        this.setFooter(false)
    },
    watch: {
        listNoticeUnread(val) {
            if (val.length === 0) {
                document.getElementsByClassName('h-right')[0].classList.add("disabled")
            }
            else document.getElementsByClassName('h-right')[0].classList.remove("disabled")
        }
    },
    computed: {
        ...mapGetters(["defaultToken"]),
        listNoticeUnread() {
            return this.noticeList.filter(e => parseInt(e.is_read) !== this.IS_READ)
        }
    },
    methods: {
        ...mapActions({
            getDefaultToken: "user/getDefaultToken",
            setFooter: "layout/setFooter",
            getNotices: "profile/getNotices"
        }),
        async getNoticeList($state) {
            if (this.noticeList.length > 0 && this.noticeList.length < this.pageSize) {
                $state.complete()
                return
            }
            let params = {
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
            };
            await this.$store
                .dispatch("profile/getNotices", params)
                .then((data) => {
                    if (data.result[0]) {
                        this.noticeList.push(...data.result);
                        this.pageCurrent++
                        $state.loaded()
                    } else {
                        $state.complete()
                    }
                })
                .catch((err) => {
                    $state.complete()
                });
        },
        goToDetail(item) {
            this.$router.push({
                name: 'noticeDetail',
                query: {
                    type: item.type ? item.type : 'notice', // type: contact & notice & schedule notice
                    id: item.id, // notice_id
                    nd_id: item.notice_done_id ? item.notice_done_id : '0', // notice done id
                    ss_id: item.schedule_send_id ? item.schedule_send_id : '', // schedule send id
                    p_at: item.posted_at, // posted_at
                }
            })
        },
        async handleReadAllNotice() {
            const notices = {}
            let index = 0
            this.listNoticeUnread.forEach(e => {
                    if (e.type) notices["item" + index] = e.id + "-"+ e.type + "-" + "null";
                    else {
                        if (e.notice_title) {
                            notices["item" + index] = e.id + "-notice-" + e.notice_done_id;
                        } else {
                            notices["item" + index] = e.id + "-schedule_notice-";
                        }
                    }
                    index++;
            })
            
            let params = {
                token: this.defaultToken,
                ...notices
            };

            await this.$store
                .dispatch("profile/readAllNotices", params)
                .then(() => {
                    this.noticeList = []
                    this.pageCurrent = 1
                    this.infiniteId++

                    this.isAlert = true
                    setTimeout(() => {
                        this.isAlert = false
                    }, 1000)
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    },
};
</script>

<style scoped>
.h-right.btn {
    font-weight: normal;
    margin-top: 10px;
    font-size: 14px;
}
.btn.disabled {
    color: #c1c1c1;
    pointer-events: none;
}
.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ellipsis-2line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: break-spaces;
}

.notice-label {
    position: absolute;
    top: 0;
    right: 0;
    border-width: 0px 30px 30px 0px;
    border-style: solid;
    border-color: transparent rgba(254,89,123,255);
    opacity: 1;
    color: white;
}

.notice-label-text {
    position: absolute;
    font-weight: bold;
    font-size: 11px;
    transform: rotateZ(45deg);
    top: 4px;
    left: 10px;
    width: 22px;
    font-size: 8px;
}
.list {
    border-bottom: none;
    border-top: 1px dotted #bdbdbd;
    padding-top: 2%;
    padding-right: 0;
}
</style>